// removed by extract-text-webpack-plugin
module.exports = {"logo":"logo--xgzNN"};